// Ties a form label, its field and the field's error together (#345, DS-3).
//
// Spread `labelProps` on the <label>, `inputProps` on the field, and `errorProps` on the element
// that shows the error. A screen reader then reads the field by its label, hears "invalid" when
// there is an error, and reads the error text with the field. The error element is an alert, so
// the error is also announced the moment it appears.
//
// `error` is the message shown for this field, or empty when the field is fine.
export function fieldProps(id, error) {
  const errorId = `${id}-error`;
  return {
    labelProps: { htmlFor: id },
    inputProps: {
      id,
      'aria-invalid': error ? 'true' : undefined,
      'aria-describedby': error ? errorId : undefined,
    },
    errorProps: { id: errorId, role: 'alert' },
  };
}
